/**
 * Helpers for File Manager ↔ OfficeGrant / WOPI editor lifecycle postMessage
 * (App_LoadingStatus, UI_Close, Action_Save_Resp).
 */

export type OfficeEditorLifecycleProvider =
  'msoffice' | 'collabora' | 'onlyoffice' | 'officegrant' | string | undefined;

/**
 * Listen when classic WOPI providers or beta `/open` (direct iframe src) is active.
 */
export function shouldListenForOfficeEditorLifecycle(params: {
  provider?: OfficeEditorLifecycleProvider;
  useDirectIframeSrc?: boolean;
}): boolean {
  if (params.useDirectIframeSrc) {
    return true;
  }
  const provider = params.provider;
  return provider === 'collabora' || provider === 'onlyoffice' || provider === 'officegrant';
}

function pushOrigin(origins: Set<string>, url: string | undefined | null): void {
  if (!url) return;
  try {
    origins.add(new URL(url).origin);
  } catch {
    /* ignore invalid URL */
  }
}

/**
 * Collect allowed origins for editor lifecycle messages.
 * Beta `/open` uses VITE_APP_OFFICEGRANT_URL / iframe src; classic uses provider server URLs.
 */
export function collectOfficeEditorLifecycleOrigins(params: {
  onlyOfficeServerUrl?: string | null;
  collaboraServerUrl?: string | null;
  officeGrantServerUrl?: string | null;
  officeGrantEnvUrl?: string | null;
  iframeSrc?: string | null;
}): string[] {
  const origins = new Set<string>();
  pushOrigin(origins, params.onlyOfficeServerUrl ?? undefined);
  pushOrigin(origins, params.collaboraServerUrl ?? undefined);
  pushOrigin(origins, params.officeGrantServerUrl ?? undefined);
  pushOrigin(origins, params.officeGrantEnvUrl ?? undefined);
  pushOrigin(origins, params.iframeSrc ?? undefined);
  return [...origins];
}
